import React from 'react';

export default function Footer() {
  return (
    <footer className='text-center'>
      <h3>
        Created by{' '}
        <a href='https://www.treezywebdesign.com/' target='_blank'>
          Treezy Web Design
        </a>
      </h3>
    </footer>
  );
}
